<template>
  <b-modal :id="modalId" :title="isEditing ? 'Edit Campaign' : 'New Campaign'" hide-footer @hidden="reset">
    <form @submit.prevent="submit">

      <div class="form-group">
        <label>Campaign name <span class="text-danger">*</span></label>
        <input type="text" class="form-control" v-model="form.name" maxlength="191" required />
        <small v-if="errors.name" class="text-danger">{{ errors.name[0] }}</small>
      </div>

      <div class="form-group">
        <label>Description</label>
        <textarea class="form-control" v-model="form.description" rows="2" maxlength="2000"></textarea>
      </div>

      <div class="form-row">
        <div class="form-group col-6">
          <label>Start date <span class="text-danger">*</span></label>
          <date-range-picker
            :single-date-picker="true"
            :auto-apply="true"
            :ranges="false"
            :append-to-body="true"
            v-model="startsAtPicker"
            class="custom-width-datepicker"
          >
            <template #input="picker">
              <span v-if="picker.startDate" class="text-dark">{{ formatPickerDate(picker.startDate) }}</span>
              <span v-else class="text-muted"><i class="bi bi-calendar-event mr-1"></i>Select date</span>
            </template>
          </date-range-picker>
          <small v-if="errors.starts_at" class="text-danger">{{ errors.starts_at[0] }}</small>
        </div>
        <div class="form-group col-6">
          <label>End date <span class="text-danger">*</span></label>
          <date-range-picker
            :single-date-picker="true"
            :auto-apply="true"
            :ranges="false"
            :append-to-body="true"
            v-model="endsAtPicker"
            class="custom-width-datepicker"
          >
            <template #input="picker">
              <span v-if="picker.startDate" class="text-dark">{{ formatPickerDate(picker.startDate) }}</span>
              <span v-else class="text-muted"><i class="bi bi-calendar-event mr-1"></i>Select date</span>
            </template>
          </date-range-picker>
          <small v-if="errors.ends_at" class="text-danger">{{ errors.ends_at[0] }}</small>
        </div>
      </div>

      <div v-if="serverError" class="alert alert-danger py-2">{{ serverError }}</div>

      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-secondary mr-2" @click="$bvModal.hide(modalId)">Cancel</button>
        <button type="submit" class="btn btn-primary" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm mr-1"></span>
          {{ isEditing ? 'Save Changes' : 'Create Campaign' }}
        </button>
      </div>

    </form>
  </b-modal>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker';

export default {
  name: 'DiscountCampaignForm',
  components: { DateRangePicker },
  props: {
    modalId:  { type: String, default: 'campaign-form-modal' },
    campaign: { type: Object, default: null },
  },
  data() {
    return {
      form:          { name: '', description: '' },
      startsAtPicker: { startDate: null },
      endsAtPicker:   { startDate: null },
      errors:        {},
      serverError:   '',
      saving:        false,
    };
  },
  computed: {
    isEditing() {
      return !!this.campaign;
    },
  },
  watch: {
    campaign(val) {
      if (val) {
        this.form.name        = val.name        || '';
        this.form.description = val.description || '';
        this.startsAtPicker   = { startDate: val.starts_at ? new Date(val.starts_at) : null };
        this.endsAtPicker     = { startDate: val.ends_at   ? new Date(val.ends_at)   : null };
      } else {
        this.reset();
      }
    },
  },
  methods: {
    async submit() {
      this.errors      = {};
      this.serverError = '';
      this.saving      = true;

      const payload = {
        name:        this.form.name,
        description: this.form.description,
        starts_at:   this.startsAtPicker.startDate
          ? moment(this.startsAtPicker.startDate).format('YYYY-MM-DD')
          : '',
        ends_at:     this.endsAtPicker.startDate
          ? moment(this.endsAtPicker.startDate).format('YYYY-MM-DD')
          : '',
      };

      try {
        let response;
        if (this.isEditing) {
          response = await axios.put(`/api/discount-campaigns/${this.campaign.id}`, payload);
        } else {
          response = await axios.post('/api/discount-campaigns', payload);
        }
        this.$emit('saved', response.data);
        this.$bvModal.hide(this.modalId);
      } catch (err) {
        if (err.response?.status === 422) {
          this.errors = err.response.data.errors || {};
        } else {
          this.serverError = err.response?.data?.message || 'An error occurred. Please try again.';
        }
      } finally {
        this.saving = false;
      }
    },

    formatPickerDate(d) {
      if (!d) return '';
      return new Date(d).toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
    },

    reset() {
      this.form          = { name: '', description: '' };
      this.startsAtPicker = { startDate: null };
      this.endsAtPicker   = { startDate: null };
      this.errors        = {};
      this.serverError   = '';
    },
  },
};
</script>
